module.exports = __webpack_public_path__ + "assets/img/9f29-ch.svg";